import styled from "styled-components";

interface IDivCheckbox {
  disabled?: any;
}
export const DivCheckbox = styled.div<IDivCheckbox>`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
      
      .checkbox-react-prime-class {
        cursor: ${props.disabled ? "not-allowed" : "pointer"};
      }
  `}

  .p-checkbox .p-checkbox-box.p-highlight {
    border-color: #002e6c;
    background: #002e6c;
    height: 1.8rem;
    width: 1.8rem;
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-highlight:hover {
    border-color: #002e6c;
    background: #002e6c;
    color: #ffffff;
    height: 1.8rem;
    width: 1.8rem;
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box:hover {
    border-color: #002e6c;
  }
  .p-checkbox:not(.p-checkbox-disabled) .p-checkbox-box.p-focus {
    box-shadow: 0 0 0 0.2rem #002e6c;
  }
  .p-checkbox .p-checkbox-box {
    border: 2px solid #ced4da;
    background: #ffffff;
    width: 1.8rem;
    height: 1.8rem;
    color: #495057;
    border-radius: 3px;
    transition: background-color 0.2s, color 0.2s, border-color 0.2s,
      box-shadow 0.2s;
  }
`;
